export enum CancelationExplanationDialogFormNamesEnum {
  FORM_GROUP_NAME = 'CancelationExplanation',
  REASON_CODE = 'ReasonCode',
  REASON_EXPLANATION = 'ReasonExplanation',
}
